<template>
    <div v-if="product" class="cart-item">
        <div class="image">
            <div class="image-1">
                <router-link :to="productLink">
                    <img :src="resizeImage(product.avatar, 80, 80)" class="img-fluid" />
                </router-link>
            </div>
        </div>
        <div class="content">
            <div class="description">
                <h4><router-link :to="productLink">{{
                    product.name }}</router-link></h4>
                    <div class="desc">Mã sản phẩm: {{ productCode(product.code) }} </div>
                <div class="price">
                    Giá ưu đãi: <span class="price-new">{{ showPrice(product) }}</span>
                    <span class="price-old">{{ price(product.oldPrice) }}</span>
                </div>

                
                <div class="d-flex">
                    <label for="num" class="col-sm-2 col-form-label">Số lượng</label>
                    <div style="flex: 1">
                        <input type="number" style="width: 100%;" id="num" class="form-control w-100" v-on:change="change($event, product)" :value="cp.quantity" step="1" min="0"  />
                    </div>
                    <div>
                        <button class="btn" @click="removeFromCart" style="margin-left: 10px;"><i class="far fa-trash-alt"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
    props: ["cp"],
    data() {
        return {
            animationStyle: "",
            showAnimation: false,
            moveAnimation: false,
        };
    },
    computed: {
        id() {
            console.log(this.cp);
            return this.cp._id;
        },
        product() {
            return this.$store.getters.product(this.id);
        },

        productLink() {
            if (this.product && this.product.name) {
                return `/san-pham/${this.removeVietnameseTones(this.product.name).replaceAll(" ", "-").toLowerCase()}/${this.productCode(this.product.code)}`;
            } else {
                return `/san-pham/san-pham/${this.productCode(this.product.code)}`;
            }
        },
    },
    components: {
    },
    mounted() {},
    methods: {
        resizeImage(link, width, height) {
            const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
            if(test) {
                // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
                return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
            } else {
                return link;
            }
        },
        showPrice(p) {
            console.log(p);
            if(p.priceMode == 1) {
                return this.price(Math.round(Number(p.oldPrice) * (100 - Number(p.priceLevel)) / 100));
            } else if(p.priceMode == 2) {
                return p.priceShortMess;
            }
            return this.price(p.price);
        },
        removeFromCart() {
            const t = this;
            
            Swal.fire({
                title: "Xác nhận xóa!",
                text: "Bạn có muốn xóa sản phẩm " + t.product.name + " ra khỏi giỏ hàng không",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Xác nhận xóa"
                }).then((result) => {
                if (result.isConfirmed) {
                    t.$store.commit("updateCart", {code: t.productCode(t.product.code), num:0});
                }
                });

        },
        change($event, product) {
            let num = $event.target.value;
            const t = this;
            console.log(product);
            console.log(num);
            if(num <= 0) {
                
            Swal.fire({
                title: "Xác nhận xóa!",
                text: "Bạn có muốn xóa sản phẩm " + product.name + "ra khỏi giỏ hàng không",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Xác nhận xóa"
                }).then((result) => {
                if (result.isConfirmed) {
                    t.$store.commit("updateCart", {code: t.productCode(t.product.code), num:Number(num)});
                } else {
                    $event.target.value = t.cp.quantity;
                }
                });

            } else {
                t.$store.commit("updateCart", {code: t.productCode(t.product.code), num:Number(num)});
            }
        },
        productCode(code) {
            if (typeof code == "string" && code.length == 8) {
                return code.substring(0, 3) + "." + code.substring(3, 5) + "." + code.substring(5);
            } else {
                return code;
            }
        },
        discount(price, oldPrice) {
            return Math.ceil(((oldPrice - price) / oldPrice) * 1000) / 10;
        },
        addToCart() {
            let dom = this.$el.querySelector('.btn-add-to-cart');
            let domImage = this.$el.querySelector('.image-1');
            let rectImage = domImage.getBoundingClientRect();

            this.animationStyle = `top: ${rectImage.top}px; left: ${rectImage.left}px; width: ${rectImage.width}px; height: ${rectImage.height}px;`;
            const t = this;
            t.showAnimation = true;
            dom.classList.add("btn-react");
            setTimeout(function () {
                dom.classList.remove("btn-react");
            }, 200)
            setTimeout(function () {
                t.moveAnimation = true;
            }, 500)

            setTimeout(function () {

                t.showAnimation = false;
                t.moveAnimation = false;
                t.$store.commit("addToCart", t.id);
            }, 1700)
        },
        removeVietnameseTones(str) {
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
            str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
            str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
            str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
            str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
            str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
            str = str.replace(/Đ/g, "D");
            // Some system encode vietnamese combining accent as individual utf-8 characters
            // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
            str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
            // Remove extra spaces
            // Bỏ các khoảng trắng liền nhau
            str = str.replace(/ + /g, " ");
            str = str.trim();
            // Remove punctuations
            // Bỏ dấu câu, kí tự đặc biệt
            str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
            return str;
        },
        price(price) {
            const config = {
                style: 'currency',
                currency: 'VND',
                maximumFractionDigits: 0
            };
            return new Intl.NumberFormat('vi-VN', config).format(price);
        },
    },
    watch: {
    },
};
</script>

<style lang="less">
#cart-item-wrap-wrap {
    display: flex;
    justify-content: center;

    #cart-item-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        max-width: 800px;

        .cart-item {
            display: flex;
            width: 100%;

            a {
                color: inherit;
                text-decoration: none;
            }

            .image {
                width: 100px;
                height: 100px;
                display: flex;
                justify-content: center;
                padding: 10px;
                border-radius: 5px;
                border: 1px solid #ccc;

                .image-1 {
                    flex-direction: column;
                    display: flex;
                    justify-content: center;
                    max-width: 80px;
                    max-height: 80px;

                    img {
                        max-width: 80px;
                        max-height: 80px;
                    }
                }
            }

            .content {
                flex: 1;
                text-align: left;
                padding-left: 20px;

                .price {
                    font-weight: 16px;

                    .price-new {
                        display: inline-block;
                        margin-right: 20px;
                        font-weight: bold;
                    }

                    .price-old {
                        text-decoration: line-through;
                        color: #999;
                    }
                }
            }
        }
    }

}
</style>